import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { catchError, filter, map, of, take } from 'rxjs';
import { TherapistClientStateService } from '@therapist/shared/services/state/therapist-client-state.service';
import { TherapistClientDto } from '@therapist/shared/models/client/therapist-client.dto';
import { GuidCheckerUtil } from '@base/utils/guid-checker.util';

export const therapistClientReadyGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const state = inject(TherapistClientStateService);
  const router = inject(Router);

  const clientId = route.paramMap.get('clientId');

  if (!clientId) {
    console.warn('therapistClientReadyGuard: No clientId in route, redirecting to 404');
    return router.createUrlTree(['/404']);
  }

  if (!GuidCheckerUtil.isValidGuid(clientId)) {
    console.warn('therapistClientReadyGuard: ClientId in route is no valid Guid, redirecting to 404');
    return router.createUrlTree(['/404']);
  }

  const selectedClient = state.getSelectedClient();
  const cached = selectedClient();

  // Schon der richtige Client im State? Sofort durchlassen.
  if (cached?.id === clientId) {
    return true;
  }

  // Laden anstoßen und warten, bis genau dieser Client im State steht.
  state.loadClientById(clientId);

  return toObservable(selectedClient).pipe(
    filter((c): c is TherapistClientDto => !!c && c.id === clientId),
    take(1),
    map(() => true),
    // Falls Laden fehlschlägt → 404
    catchError(() => {
      console.warn('therapistClientReadyGuard: Loading client failed, redirecting to 404');
      return of(router.createUrlTree(['/404']));
    })
  );
};
